<template>
    <a-modal
        centered
        :visible="visible"
        title="发起订单"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="order-create" :rules="rules">
            <a-form-model-item label="买家用户ID" prop="member_id">
                <a-select
                    class="spotlight"
                    show-search
                    :show-arrow="false"
                    :dropdownMatchSelectWidth="false"
                    placeholder="快速搜索姓名、手机号码..."
                    :filter-option="false"
                    @search="on_membersearch"
                    style="transition:0.2s width"
                    option-label-prop="name"
                    v-model="form.member_id"
                >
                    <a-spin v-if="loading_member" slot="notFoundContent" size="small" />

                    <a-select-opt-group v-for="d in data_member" :key="d.id">
                        <span slot="label">
                            <a-icon type="user" />
                            {{ d.name }}
                        </span>
                        <a-select-option :value="d.id" :key="d.id" :name="d.name" :item="d">
                            <div>
                                <a-icon type="mobile" />
                                {{ d.mobile }}
                            </div>
                        </a-select-option>
                    </a-select-opt-group>
                </a-select>
            </a-form-model-item>

            <a-form-model-item
                label="商标注册号"
                prop="apply_no"
                :extra="data_trademark ? '读取成功，商标价格：¥' + data_trademark.price : ''"
            >
                <a-input-search v-model="form.apply_no" placeholder="输入商标注册号" @search="on_read_trademark">
                    <a-button slot="enterButton" type="primary">
                        读取数据
                    </a-button>
                </a-input-search>
            </a-form-model-item>

            <a-form-model-item label="媒介" prop="member_id">
                <a-select v-model="form.mediator_id">
                    <a-select-option v-for="user in data_user" :key="user.id" :value="user.id">{{ user.name }}</a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="订单价格" prop="amount">
                <a-input v-model="form.amount"></a-input>
            </a-form-model-item>

            <a-form-model-item label="订单备注">
                <a-textarea v-model="form.remark"></a-textarea>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        apply_no: null,
        mediator_id: null,
        member_id: null,
        amount: null,
        remark: null,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            callback: null,
        },
        data() {
            return {
                submitting: false,
                loading_member: false,
                data_member: [],
                data_trademark: null,
                data_user: [],
                rules: {
                    member_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    apply_no: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
            // this.load_group();
            // this.load_role();

            this.get_users();
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_membersearch(v) {
                this.loading_member = true;
                this.$http
                    .get(`/member/accessible?type=plain&wd=${v}`)
                    .then((response) => {
                        if (response.success) {
                            this.data_member = response.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading_member = false;
                    });
            },
            get_users() {
                this.$http
                    .get(`/auth/user/accessible_by_as?as=order_trademark.generate`)
                    .then((response) => {
                        if (response.success) {
                            this.data_user = response.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            on_submit() {
                this.submitting = true;
                this.$http
                    .post("/order_trademark/prepare", this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            this.$message.success(res.message);
                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            after_close() {
                this.$refs["order-create"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
            on_read_trademark() {
                let apply_no = this.form.apply_no;
                if (!apply_no) {
                    return false;
                }

                this.data_trademark = null;

                this.$http
                    .get("/trademark/" + apply_no)
                    .then((res) => {
                        if (res.success) {
                            this.data_trademark = res.data;
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
        },
    };
</script>
